module.exports = __webpack_public_path__ + "img/sercomtel.187be3c6.png";